
<main class="reference_form-main">
  <div class="main_container">
    <form [formGroup]="seismicpartyForm">
    <div class="">
      <h3 class="form_name">SeismicParty</h3>


        <div class="input">
          <label for="">Party Chief Name</label>
          <input type="text" class="default_input reference-form" formControlName="PartyChiefName" />
        </div>


      <div class="btn_holder">
        <button class="default_primary-button" (click)="addNew(seismicpartyForm.value)">Add</button>
        <button class="default_secondary-btn ml-2" (click)="onClearForm()">Reset</button>

      </div>

    </div>
  </form>
    <div class="display_table" >
      <div class="search_container">
        <input type="text" class="default_input search"
        placeholder="Search for SeismicParty"
        [formControl]="control"
        [appAutocomplete]="autocomplete"
        />
        <em class="ti-search"></em> 

        <app-autocomplete #autocomplete="appAutocomplete">
          <ng-template appAutocompleteContent>
            <ng-container
              *ngIf="(contractors | filterReference: control.value) as result"
            >
            <app-option
            (click)="selectContractor(option.id)"
            *ngFor="let option of result"
            [value]="option.ContractorName"
          >
            {{ option.ContractorName }}
          </app-option>
          <app-option class="no-result" *ngIf="!result.length"
            >No result...</app-option
          >
            </ng-container>
          </ng-template>
        </app-autocomplete>
      </div>

      <div class="head" >
        <span class="item">S/N</span>
        <span class="item">Party Chief Name</span>
        <span class="item">Action</span>

      </div>

    <div class="scroll">

    </div>
    <div class="body_content" *ngIf="status">
      <div class="the_body"
      *ngFor="let seismicparty of seismicpartyFormArray.get('SeismicPartys')['controls']; index as i"
      (click)="onEdit(i, seismicparty.value)" style="cursor: pointer;"
      matTooltip="Click to edit"
        aria-label="Button that displays a tooltip when focused or hovered over"
      >
        <span class="content">{{i + 1}}</span>
        <span class="content">{{seismicparty.value.PartyChiefName}}</span>
        <span class="content" (click)="$event.stopImmediatePropagation()">
          <button
          class="delete_icon trash"

          (click)="deleteSeismicParty(i, seismicparty.value)">
          <em class="ti-trash"> </em> </button>
        </span>

      </div>
      </div>
      <div class="btn_holder">
        <button class="default_primary-button" (click)="onSubmit(seismicpartyFormArray.value)">Submit</button>
      </div>
    </div>
  </div>
</main>

<div class="box green_box"></div>
<div class="box pink_box"></div>
